import { useQuery } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { UserApi } from '@/Domain/api/User/User.api';

export const useUser = () => {
  const { data, isLoading } = useQuery({
    queryKey: [Endpoint.user.myself],
    queryFn: () => UserApi.myself(),
  });

  return {
    user: data,
    isLoading,
  };
};
